import {Action} from "redux";
import {IClientScoutCustomerListActionCreator} from "../action/client_scout_customers_action";

import {SearchCustomerListByClientRequest,} from "../request/scout_request";

interface IClientScoutCustomerListDispatcher {
    searchCustomerList(item: SearchCustomerListByClientRequest): void;
}

class Dispatcher implements IClientScoutCustomerListDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientScoutCustomerListActionCreator) {

    }

    public searchCustomerList = (item: SearchCustomerListByClientRequest): void => {
        this.dispatch(this.actionCreator.requestSearchCustomerListAction(item));
    }

}

const createScoutCustomerListDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientScoutCustomerListActionCreator): IClientScoutCustomerListDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientScoutCustomerListDispatcher, createScoutCustomerListDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_scout_customers_dispatcher.ts